<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <div class="bc_ico">
                <a href="JavaScript:" @click="goMain">{{$t('FIELD.GLOBAL.PAGEINFO.HOME')}}</a> <em><span class="sr_only">&gt;</span></em> {{$t('TITLE.SEARCH.CUSTOMER')}}
                <em><span class="sr_only">&gt;</span></em> {{pageTitle}}
            </div>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_filter">
                    <dl class="dl_input">
                        <dt>{{$t('FIELD.GLOBAL.CATEGORY')}}</dt>
                        <dd data-input-type="select">
                            <fieldset class="ui_fieldset set_3">
                                <div>
                                    <select class="slt_white w100p" id="prod1" v-model="prodCateCd1" @change="changeProdCd(1)">
                                        <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                        <option v-for="code in prodCategories1" :key="code.code" :value="code.code">{{code.codeNm}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p" id="prod2" v-model="prodCateCd2" @change="changeProdCd(2)">
                                        <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                        <option v-for="code in prodCategories2" :key="code.code" :value="code.code">{{code.codeNm}}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="slt_white w100p" id="prod3" v-model="prodCateCd3">
                                        <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                        <option v-for="code in prodCategories3" :key="code.code" :value="code.code">{{code.codeNm}}</option>
                                    </select>
                                </div>
                            </fieldset>
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>{{$t('FIELD.CODE.TITLE')}}</dt>
                        <dd data-input-type="input">
                            <span class="clearable">
                                <input type="text" class="text_input w100" @keyup.enter.stop="onSearch(1)" v-model="title" v-clearable />
                                <i class="clearable_clear">X</i>
                            </span>
                        </dd>
                        <dt>{{$t('FIELD.GLOBAL.MODEL')}}</dt>
                        <dd data-input-type="input">
                            <span class="clearable">
                                <input type="text" class="text_input w100" @keyup.enter.stop="onSearch(1)" v-model="modelCd" v-clearable />
                                <i class="clearable_clear">X</i>
                            </span>
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>{{$t('FIELD.GLOBAL.CREATE')}} {{$t('FIELD.GLOBAL.DATE.DATE')}}</dt>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>Site</dt>
                        <dd data-input-type="select">
                            <select class="slt_white w100p" v-model="siteCd">
                                <option value='' selected>All site</option>
                                <option v-for="code in cdSites" :key="code.cdSide" :value="code.cdSite">{{code.cdSite}}</option>
                            </select>
                        </dd>
                        <dt>{{$t('FIELD.GLOBAL.SYMPTOM')}}</dt>
                        <dd data-input-type="select">
                            <select class="slt_white w100p" v-model="symptom">
                                <option value='' selected>Select</option>
                            </select>
                        </dd>
                    </dl>
                </article>
                <div class="filter_btn">
                    <a href="JavaScript:" @click="onSearch(1)" class="btn_srch">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                </div>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                <div class="btn_wrap">
                    <a href="JavaScript:" class="btn_white" @click="excelDownload()">{{$t('BUTTON.GLOBAL.EXCELDOWNLOAD')}}</a>
               </div>
                
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :pageOptions="pageOptions"
                    :key="gridKey"
                    :click="contentClick"
                    :isTotalCount="false"
                />
                
                <div class="paginate">
                    <sdl-pagination
                        :current-page="currentPage"
                        :total-rows="resultCount"
                        :per-page="perPage"
                        @change="onSearch"
                        align="center"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Vue                  from 'vue';
import axios                from 'axios';
import qs                   from 'query-string';
import _                    from 'lodash';
import $                    from 'jquery';
import moment               from 'moment';
import { mapGetters }       from 'vuex';
import SDLPagination        from '~~c/control/pagination/Pagination';
import {SDLUtil, MenuUtil}  from '@/utils';
import { EventBus }         from '@/utils/EventBus';
import AscToastGrid         from '~c/ToastGrid';
import DotComSnb            from './DotComSnb';
import ToastGrid            from '~c/ToastGrid';
import SKPBreadcrumbs       from '~vb/main/SKPBreadcrumbs';
import DatePicker           from '~c/DatePicker';
import { CellHtmlRenderer, HeaderHtmlRenderer, } from '~c/GridCustomRenderer';
import ExcelDownloadPopup   from '~vb/common/ExcelDownloadPopup';
import constants    from '@/constants';

require('moment-jdateformatparser');

const fetchDotCom = dotComMenuNm => axios.post(
    `${SDLUtil.API_URL}/basis/admin/dotcom/DotcomSupportCert.skp`,
    qs.stringify({ dotComMenuNm: dotComMenuNm }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid Tooltip renderer
class Tooltip {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        if (resVal) {
            el.innerText = resVal;
            el.title = resVal;
        } else {
            el.innerText = '-';
            el.title = 'no value';
        }       
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

// ToastGrid Type renderer
class StatusType {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        if (resVal == 'S') resVal = 'Submit';
        else if (resVal == 'A') resVal = 'Approval';
        else if (resVal == 'D') resVal = 'Delete';
        el.innerText = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

// ToastGrid Type renderer
class PreviewRender {
    constructor(props) {
        const el = document.createElement('a');
        el.classList.add('btn_sm_white');
        el.innerText = 'Preview3.0';
        el.href = 'javascript:';
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

export default {
    name: 'SearchAscList',
    props: {
//        params: {}
    },
    components: {
        'toast-grid'      : ToastGrid,
        'skp-breadcrumbs' : SKPBreadcrumbs
    },
    data() {
        return {
            menuMode: 'FAQ',
            isLoading: true,
            pageTitle : '',
            cdSites:[],
            languages:[],
            siteCd: '', // Site
            title: '', // Title
            symptom: '', // Symptom(not use)
            register: '', // Register
            lang:'', // Language
            seqNo: '', // Seq No
            status: '', // Status
            modelCd: '', // Model
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            FR_DATE: '',
            TO_DATE: '',
            certParams: '',
            recentModels: [],
            autoCompletes: [],
            gridData: [],
            resultCount: 0,
            gridId: 'faqGrid',
            gridKey: 1,
            resultCount: 0,
            pageOptions: {},
            ORDER_COLUMN: '',
            ORDER_DIR: '',
            columns: [
                {
                    header: 'Site',
                    name: 'CD_SITE',
                    align: 'center',
                    width: '60',
                    sortable: false
                },
                {
                    header: 'Seq',
                    name: 'T_SEQ',
                    align: 'center',
                    width: '80',
                    sortable: false
                },
                {
                    header: 'Subject',
                    name: 'TITLE',
                    align: 'left',
                    renderer : {type : Tooltip},
                    sortable: false
                },
                {
                    header: 'Category(IA) & Model',
                    name: 'IA_LEVEL',
                    align: 'left',
                    renderer : {type : Tooltip},
                    width: '280',
                    sortable: false
                }
            ],            
            options: {
                scrollX: false,
                scrollY: false,
            },
            prodCateCd1: '',
            prodCateCd2: '',
            prodCateCd3: '',
            prodCateNm1: '',
            prodCateNm2: '',
            prodCateNm3: '',
            prodCategories1: [],
            prodCategories2: [],
            prodCategories3: [],
            naviName: ''
        };
    },
    computed: {
        ...mapGetters({
            userCorpCd: 'getCorpCd',
        }),
    },
    methods: {
        async initCertLoad() {
            return await fetchDotCom(this.dotComMenuNm).then(resp => {
                Object.assign(resp.data, { corpNo : this.userCorpCd });
                this.certParams = '&' + Object.entries(resp.data).map(e => e.join('=')).join('&');
            }).catch(err => {
                SDLUtil.errorAlert(err);
            });
        },
        async initCommCodes() {
            const param = {};

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/admin/dotcom/getCommCodes.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.cdSites = resp.data.cdSites;
                    this.languages = resp.data.languages;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    console.log('Err.init ======> ', err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // rowDelete, search(검색어 등록)
        async execServer(url, param) {
            return await axios
                .post(url, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
//                    console.log('save result ==> ', resp.data);
                    this.init();
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        loadProducts(mode, param) {
            param.depth     = mode;
            return axios.post(
                `${SDLUtil.API_URL}/basis/admin/dotcom/getCategories.skp`,
                qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                },
            ).then(resp => {
//                console.log('Category.resp ==> ', resp);
                if (mode == 1) { // product 1depth
                    this.prodCategories1 = resp.data;
                    param.parentCode     = this.prodCateCd1;
                    if (this.prodCateCd1) this.loadProducts(2, param);
                    else {
                        this.prodCateCd2   = '';
                        this.prodCateCd3   = '';
                    }
                } else if (mode == 2) { // product 2depth
                    this.prodCategories2 = resp.data;
                    this.prodCateCd2   = '';
                    this.prodCateCd3   = '';
                    if (this.prodCateCd2) {
                        param.parentCode = this.prodCateCd2;
                        this.loadProducts(3, param);
                    }
                } else if (mode == 3) { // product 3depth
                    this.prodCategories3 = resp.data;
                    if (resp.data.length == 0) {
                        this.prodCateCd3 = '';
                    }
                }
            }).catch(err => {
                console.log('Error occured : ', err);
            });
        },
        changeProdCd(mode) {
            if (mode == 1) { // product code - 1Depth
                if (this.prodCateCd1 == '') {
                    this.prodCategories2 = [];
                    this.prodCategories3 = [];
                    this.prodCateCd2 = '';
                    this.prodCateCd3 = '';
                } else {
                    let param = {parentCode: this.prodCateCd1};
                    this.loadProducts(2, param);
                }
            } else if (mode == 2) { // product code - 2Depth
                if (this.prodCateCd2 == '') {
                    this.prodCategories3 = [];
                    this.prodCateCd3 = '';
                } else {
                    let param = {parentCode: this.prodCateCd2};
                    this.loadProducts(3, param);
                }
            }
        },
        getSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;
            
            let prodCateCd = '';
            if (this.prodCateCd3) {
                prodCateCd = this.prodCateCd3;
            } else if (this.prodCateCd2) {
                prodCateCd = this.prodCateCd2;
            } else if (this.prodCateCd1) {
                prodCateCd = this.prodCateCd1;
            }
            const mFormat = localStorage.getItem('mDateFormat');
            let FRDT = this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '';
            let TODT = this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '';

            let params = {
                menuMode: this.menuMode, // HTG, HTV, TSG
                page: pageNo,
                currentPage: pageNo,
                perPage: this.perPage,
                siteCd: this.siteCd,
                startDt : SDLUtil.convertDate(FRDT),
                endDt : SDLUtil.convertDate(TODT),
                prodCateCd : prodCateCd,
                title: this.title,
                register: this.register,
                lang: this.lang,
                seqNo: this.seqNo,
                status: this.status,
                modelCd:  this.modelCd,
                ORDER_COLUMN: this.ORDER_COLUMN,
                ORDER_ASC: this.ORDER_DIR,
            };
            return params;
        },
        onSearch(pageNo) {
            if (!pageNo) pageNo = 1;

            if (!this.siteCd) {
                SDLUtil.alert('Please select [Site].');
                return false;
            }

            const formData = this.getSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/dotcom/getSupportQaList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
//                    console.log('onSearch.resp ===>>> ', resp);
                    this.resultCount = resp.data.totalCount;
                    this.gridData = resp.data.rows;

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        // 그리드 row 클릭 시... 상세페이지로 이동
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;

            let colNm = event.columnName;
//            if (colNm != 'PREVIEW') return; // 2020.07.30 수정

            let item = this.gridData[event.rowKey];
            const aemParam = '?seq=' + item.T_SEQ + '&cdsite=' + item.CD_SITE + '&cdcnt=' + this.menuMode;
            let url = SDLUtil.DOTCOM_URL + '/admin/QA/FAQ_QA_AEM_Preview_Proc.jsp' + aemParam + this.certParams;
            console.log('url ==> ', url);

            SDLUtil.openLegacyWindowPopup({
                url: url,
                title: 'previewNext',
                w: 810,
                h: 850
            });
        },
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    const formData = this.getSearchParams(1);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/dotcom/excelDownloads.skp`,
                            qs.stringify(formData),
                        )
                        .then(resp => {
                            console.log('resp ===> ', resp);
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show (
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        goMain() {
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
        }
    }, // methods
    watch: { // keyword를 clearable로 지웠을 때...
    },
    created() {
        this.menuMode = this.$route.query.menuMode;
/*      2020-07-23 삭제
        if (this.menuMode == 'FAQ') {
            this.columns.push(
                {
                    header: 'Related Model',
                    name: 'SEARCH_MODEL',
                    align: 'center',
                    width: '150',
                    sortable: false
                }
            );
        }
*/
        let addCols = [
                {
                    header: 'Update Date',
                    name: 'UDT_DT',
                    align: 'center',
                    width: '90',
                    sortable: false
                },
                {
                    header: 'Preview',
                    name: 'PREVIEW',
                    align: 'center',
                    sortable: false,
                    width: '90',
                    renderer: { type: PreviewRender }
                }
        ];

        if (this.menuMode == 'HTV') {
            this.columns.push(
                {
                    header: 'Video ID/Status',
                    name: 'VIDEO_STATUS',
                    align: 'center',
                    renderer : {type : Tooltip},
                    width: '140',
                    sortable: false
                }
            );
        }
        addCols.forEach(elm => {
            this.columns.push(elm);
        });
    },
    mounted() {

        this.initCommCodes(); // 공통코드들 조회
        this.loadProducts(1, { parentCode : 0 }, true);
        this.initCertLoad();

//        this.$nextTick(() => {
/*            let toDate   = new Date();
            let fromDate = new Date().setMonth(new Date().getMonth() - 1); // 1개월을 기본으로..
            this.FR_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {}, fromDate);
            this.TO_DATE = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {}, toDate);
*/            
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                SDLUtil.nvl(this.getFromDate, (new moment()).add(-1, 'years').toDate()),
                SDLUtil.nvl(this.getToDate, (new moment()).toDate())
            );

/*             this.$nextTick(() => {

                this.rangePicker = DatePicker.createRangeWithOpener(
                    'from-picker-container', 'fromDate', 'icoFromDate',
                    'to-picker-container', 'toDate', 'icoToDate',
                    { type: 'date', locale: 'en', showToday: false },
                    (new moment()).add(-1, 'years').toDate(),
                    (new moment()).toDate()
                );
            });
 */
//        });

        if (this.menuMode == 'FAQ') this.pageTitle = 'FAQ';
        else if (this.menuMode == 'HTG') this.pageTitle = 'How To Guide';
        else if (this.menuMode == 'HTV') this.pageTitle = 'How To Video';
        else if (this.menuMode == 'TSG') this.pageTitle = 'TroubleShooting';
//        console.log('SDLUtil.DOTCOM_URL ==> ', SDLUtil.DOTCOM_URL);
    },
    beforeDestroy() {
//        EventBus.$off('goCodeList');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/dotcom/DotComQaList.vue